import {
  LOADING,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_ACCESS_TOKEN,
  SET_CURRENT_USER_STATUS,
  SET_CURRENT_WEBSITE,
  SET_MESSAGE,
  SET_WEBSITE_LIST,
  IS_FIRST_LOAD,
} from "../../Actions/Types";
import { SocialLoginActionApi } from "../../Api/UserAction/LoginActionApi";
import { DomainDetailsService } from "../DomainService/DomainDetails";
import { getPlanListService } from "../PlanListService";

// service to perform social login
const SocialLoginService = async (
  username: string,
  email: string,
  sub: string,
  dispatch: Function,
  navigate: Function,
  t: Function
) => {
  console.log("SocialLoginService is called", email);

  // Start loading
  dispatch({ type: LOADING, payload: true });

  try {
    // 🔹 API call
    const autoLoginRes = await SocialLoginActionApi(username, email, sub);

    console.log("autoLoginRes", autoLoginRes);

    // 🔹 Validate response
    if (!autoLoginRes?.Data || !autoLoginRes?.token) {
      throw new Error("Invalid login response");
    }

    // 🔹 Get plan list
    getPlanListService(autoLoginRes.token, 2, dispatch);

    let currentUserType: number;

    if (autoLoginRes.Data.department === 4) {
      currentUserType = autoLoginRes.Data.is_multiple_domain === 1 ? 3 : 2;
    } else if (autoLoginRes.Data.is_multiple_domain === 2) {
      currentUserType = 4;
    } else {
      currentUserType = 1;
    }

    // 🔹 Set user status
    dispatch({
      type: SET_CURRENT_USER_STATUS,
      payload: {
        currentUserType,
        isInitUser: autoLoginRes.Data.website_lists.length === 0,
      },
    });

    // 🔹 Save token
    dispatch({
      type: SET_ACCESS_TOKEN,
      payload: autoLoginRes.token,
    });

    // 🔹 Save user
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { user: autoLoginRes.Data },
    });

    // 🔹 Website list
    dispatch({
      type: SET_WEBSITE_LIST,
      payload: autoLoginRes.Data.website_lists,
    });

    // 🔹 Handle websites
    if (autoLoginRes.Data.website_lists.length > 0) {
      const currentWebsiteID = autoLoginRes.Data.website_lists[0].id;

      const domainRes = await DomainDetailsService(
        autoLoginRes.token,
        currentWebsiteID,
        dispatch
      );

      if (domainRes.status === 200) {
        navigate("/front");

        dispatch({
          type: SET_MESSAGE,
          payload: {
            toast_message: t("Login Success Msg"),
            toast_type: "success",
            onclose: null,
          },
        });
      }
    } else {
      // 🔹 No domain found
      navigate("/front/getting-started");

      dispatch({ type: SET_WEBSITE_LIST, payload: null });
      dispatch({ type: SET_CURRENT_WEBSITE, payload: null });
    }
  } catch (error: any) {
    console.error("Social login error:", error);

    dispatch({ type: LOGOUT });
    dispatch({ type: IS_FIRST_LOAD, payload: false });

    navigate("/front/login?logout");

    let message = t("Something went wrong. Please try again later.");

    // 🔴 Unauthorized IP (message OR status based)
    if (
      error?.response?.status === 401 ||
      error?.response?.status === 403 ||
      error?.response?.data?.message ===
        "Unauthorized IP address. Please log in from an approved system or network."
    ) {
      message = t(
        "Unauthorized IP address. Please log in from an approved system or network."
      );
    }
    // 🔴 Server error
    else if (error?.response?.status === 500) {
      message = t("Server error. Please try again later.");
    }

    dispatch({
      type: SET_MESSAGE,
      payload: {
        toast_message: message,
        toast_type: "danger",
        onclose: null,
      },
    });
  } finally {
    // 🔹 Always stop loading
    dispatch({ type: LOADING, payload: false });
  }
};

export { SocialLoginService };
